import { details } from "./details";

export const clients = {
	title: "Clientes",
	atEventNameTitle: "en {{eventName}}",
	thisEventTitle: "en este Evento",
	fileTitle: "Clientes en el evento {{eventName}} {{eventDate}}",
	filename: "clientes_en_el_evento_{{eventName}}_{{eventDate}}",
	searchPlaceholder: "Buscar por nombre, RFC o teléfono",
	period: "Período",
	until: "Hasta",
	onlyClientsCheckbox: "Clientes con facturas no emitidas",
	issueAllInvoicesButton: "Emitir todas las facturas",
	table: {
		name: "Nombre",
		document: "RFC",
		phone: "Teléfono",
		checkInTime: "Horario de entrada",
		checkOutTime: "Horario de salida",
		housePrePaidTransactionsValue: "Pre-pago en el local",
		housePostPaidTransactionsValue: "Post-pago en el local",
		appTransactionsValue: "Pagado por app",
		bonusTransactionsValue: "Pagado con bono",
		total: "Total",
		noDataText: "Sin datos para mostrar.",
	},
	details,
	issueLoading: "Emitiendo facturas...",
	issuedInvoice: "factura fue emitida con éxito",
	issuedInvoices: "facturas fueron emitidas con éxito",
	errorCountIssuedInvoice: "tipo de error fue encontrado al emitir facturas",
	errorCountIssuedInvoices: "tipos de error fueron encontrados al emitir facturas",
};
